module.exports = __webpack_public_path__ + "img/aibee-logo.a14ec610.svg";